export function getLanguagePath() {
    const storedLanguage = localStorage.getItem('lng');

    if (storedLanguage) return storedLanguage;

    const frDomains = [
        'lds-frontend-staging.pblx.nl',
        'employeur.lunettesdesociete.be',
    ];

    return frDomains.includes(window.location.hostname) ? 'fr' : 'nl';
}
